// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"665":"53e8a90d","854":"84715dff"}[chunkId] + ".chunk.js";
};